if (!customElements.get('approval-remove')) {
    class ApprovalRemove extends HTMLElement {

        constructor() {
            super();
            this.key = this.dataset.key;
            this.originalKey = this.key;
            this.item = JSON.parse(document.querySelector(`[data-item="${this.key}"]`)?.innerText);
            this.checkbox = this.querySelector('input');
        }

        connectedCallback() {
            this.checkbox.addEventListener('change', this.handleClick.bind(this));
        }

        disconnectedCallback() {
            this.checkbox.removeEventListener('change', this.handleClick.bind(this));
        }

        async handleClick(e) {

            window.checkout.loading = true;

            this.item = JSON.parse(document.querySelector(`[data-item="${this.originalKey}"]`)?.innerText);

            const updateProperties = {
                ...this.item.properties,
                '_canceled': !this.item.properties['_canceled'],
            };
            
            LocalCart.updateProps(this.item.id, updateProperties);

            const { items } = LocalCart.getState();
            const updatedItem = items.find(({ properties }) => JSON.stringify(properties) == JSON.stringify(updateProperties));

            document.querySelector(`[data-item="${this.originalKey}"]`).innerText = JSON.stringify(updatedItem);

            const element = document.querySelector(`[data-line-item-key="${this.originalKey}"]`);

            if (updatedItem.properties['_canceled']) {
                element.classList.add('canceled');
                document.getElementById(`${this.originalKey}_CANCELLATION`).click();

                document.querySelectorAll(`input[type="radio"][name="${this.originalKey}"]`).forEach(e => {
                    e.disabled = true;
                    e.setAttribute('aria-disabled', 'true');
                });

            } else {
                element.classList.remove('canceled');

                document.querySelectorAll(`input[type="radio"][name="${this.originalKey}"]`).forEach(e => {
                    e.disabled = false;
                    e.removeAttribute('aria-disabled');
                });

                if (document.getElementById(`${this.originalKey}_NEXT_DELIVERY`)) {
                    document.getElementById(`${this.originalKey}_NEXT_DELIVERY`).click();
                } else if (document.getElementById(`${this.originalKey}_PARTIAL`)) {
                    document.getElementById(`${this.originalKey}_PARTIAL`).click();
                }
            }

            await window.checkout.handleUpdate();
        }
    }

    customElements.define('approval-remove', ApprovalRemove);
}